module.exports = __webpack_public_path__ + "static/media/logo-donts-5.a37c3c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-donts-5.png
// module id = 1308
// module chunks = 0